// Any config specific to Georgia?

export default {
  code: 'GE',
  countryName: 'Georgia',
  // googleSiteVerificationCode: '1uUi471agIlOfQQ3ns5BSv78-YAYOVbuPdRyGUsfq2I',
  googleSiteVerificationCode: [
    'X1B_9GgrzG2rdOXBoOKgIif4kvi8_HixLZ0Ouh6Hd3E',
    'gwa0zz_wJlO1WKDnawM4mOWqpiXJcz0LM581VzfJpeo'
  ],
  countryDomain: 'https://www.carrefour.ge',
  helplineNumber: '+995322177070',
  latitude: 41.72331935007176,
  longitude: 44.748498102987135,
  countryFlagIcon: 'GE_5ee57ae866.png',
  defaultAreaCode: 'Ilia Chavchavadze avenue - Vake - Tiblisi',
  features: {
    languageChange: true,
    now: true,
    share: false,
    isLocationCXEnable: true,
    cashback: false,
    linkMyClubCard: true,
    oneTrustScript: '5df552d9-d5e8-4e08-846d-bf36a1a16ea3'
  }
}
